import React from 'react';
import { FadeIn } from './Shared';
import { CheckCircle2 } from 'lucide-react';
export const ProductBreakdown = () => {
  const tomos = [{
    icon: '📘',
    title: 'Tomo 1 — El Código de la Calma',
    desc: 'La neurología del berrinche. Por qué pasa, qué ocurre en el cerebro de tu hijo y en el tuyo, y por qué las respuestas instintivas siempre empeoran todo.'
  }, {
    icon: '📗',
    title: 'Tomo 2 — El Protocolo SOS de los 90 Segundos',
    desc: 'Intervención en tiempo real. El protocolo P.A.U.S.A. paso a paso para los próximos 90 segundos de cualquier crisis. Con guión exacto para 5 escenarios.'
  }, {
    icon: '📙',
    title: 'Tomo 3 — El Detector de Humo',
    desc: 'Prevención antes del pico. Cómo detectar las señales antes de que explote todo. El Mapa de Momentos Críticos de tu familia y los 10 Minutos de Oro.'
  }, {
    icon: '📕',
    title: 'Tomo 4 — Límites con Amor',
    desc: 'Firmeza sin guerra. Cómo sostener un límite con calma, sin negociar, sin gritar y sin que el vínculo sufra. El Protocolo de 4 Pasos.'
  }, {
    icon: '📓',
    title: 'Tomo 5 — Reparación y Vínculo',
    desc: 'Cuando vos también explotaste. Qué hacer después. Cómo reparar el vínculo cuando fallaste. Por qué reparar bien vale más que no fallar nunca.'
  }, {
    icon: '📔',
    title: 'Tomo 6 — Kit de Emergencia Móvil',
    desc: 'Todo el sistema en el bolsillo. Las 6 Fichas de Rescate, el Diccionario de Traducción, frases listas y el sistema completo en una página. Para usar en el momento.'
  }];
  const includes = ['Explicación clara sin jerga técnica', 'Protocolo paso a paso aplicable hoy', 'Frases exactas para cada situación', 'Hojas de trabajo completables', 'Versión resumen para consulta rápida', 'Vista previa del tomo siguiente', 'Branding premium — Listo para usar en celular o impreso', 'Compatible con crianza respetuosa y crianza con autoridad'];
  return <section className="pt-4 md:pt-6 pb-8 md:pb-12 px-4 bg-navy-800/30" data-id="element-282">
      <div className="max-w-5xl mx-auto" data-id="element-283">
        <FadeIn data-id="element-284">
          <div className="text-center mb-10" data-id="element-285">
            <div className="inline-block bg-yellow-400/10 text-yellow-400 px-4 py-1 rounded-full text-xs font-bold tracking-wider mb-3 border border-yellow-400/30 shadow-[0_0_15px_rgba(250,204,21,0.2)]" data-id="element-286">
              EL SISTEMA COMPLETO
            </div>
            <h2 className="text-2xl md:text-4xl font-serif font-bold text-white mb-2 drop-shadow-[0_2px_10px_rgba(255,255,255,0.1)]" data-id="element-287">
              🏆 MEGAPACK CALMA TOTAL™
            </h2>
            <p className="text-base text-yellow-100/90 font-medium" data-id="element-288">
              6 Tomos + 4 Bonos + Método Raíces. 350+ páginas — Todo resuelto.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 items-center mb-16" data-id="element-289">
            <div className="space-y-4" data-id="element-290">
              {tomos.map((tomo, index) => <div key={index} className="bg-navy-800/80 p-5 rounded-xl border border-navy-600 hover:border-yellow-400/40 hover:bg-navy-800 transition-all pt-[20px] pb-[20px] mt-[10px] mb-[10px] shadow-lg hover:shadow-[0_0_20px_rgba(250,204,21,0.1)] group" data-id="element-291">
                  <div className="flex items-start" data-id="element-292">
                    <span className="text-3xl mr-4 group-hover:scale-110 transition-transform origin-center" data-id="element-293">
                      {tomo.icon}
                    </span>
                    <div data-id="element-294">
                      <h3 className="text-xl font-bold text-white mb-2 group-hover:text-yellow-400 transition-colors" data-id="element-295">
                        {tomo.title}
                      </h3>
                      <p className="text-gray-200" data-id="element-296">{tomo.desc}</p>
                    </div>
                  </div>
                </div>)}
            </div>
            <div className="relative" data-id="element-297">
              <div className="absolute inset-0 bg-yellow-400/10 blur-[60px] rounded-full" data-id="element-298"></div>
            </div>
          </div>

          <div className="bg-gradient-to-b from-navy-800 to-navy-900 border border-navy-600 rounded-2xl p-8 md:p-10 pt-[0px] pb-[0px] shadow-2xl relative overflow-hidden" data-id="element-299">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-3/4 h-1 bg-gradient-to-r from-transparent via-yellow-400/50 to-transparent" data-id="element-300" />
            <h3 className="text-xl md:text-2xl font-serif font-bold text-center text-white mt-[24px] mb-[24px]" data-id="element-301">
              Cada tomo incluye:
            </h3>
            <div className="grid sm:grid-cols-2 gap-4 mb-[24px]" data-id="element-302">
              {includes.map((item, index) => <div key={index} className="flex items-center space-x-3 bg-navy-900/80 border border-navy-700 p-4 rounded-lg hover:border-green-400/30 transition-colors" data-id="element-303">
                  <CheckCircle2 className="w-5 h-5 text-green-400 flex-shrink-0 drop-shadow-[0_0_5px_rgba(74,222,128,0.5)]" data-id="element-304" />
                  <span className="text-white font-medium" data-id="element-305">{item}</span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};